export default __webpack_public_path__ + "static/media/light-down-arrow-svgrepo-com.2e784c32.svg";